import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import util from '@utils/util';
import error from '../common/error';
import api from '../js/api';
import selectCountry from '../common/select';
import phoneInput from '../common/phoneInput';
import desc from '../common/desc';
import title from '../common/title';
import button from '../common/button';
export default {
  name: 'phoneparent',
  props: {
    wayType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      phone: '',
      code: '1',
      country: 'AS',
      errorTxt: '',
      cover: false
    };
  },
  computed: {
    actBtn: function actBtn() {
      return !!this.phone && !this.errorTxt;
    }
  },
  components: {
    'error-tip': error,
    'select-country': selectCountry,
    'phone-input': phoneInput,
    'button-wrap': button,
    'desc-txt': desc,
    'title-txt': title
  },
  methods: {
    changeErrorTxtHandle: function changeErrorTxtHandle(txt) {
      this.errorTxt = txt;
    },
    changePhoneHandle: function changePhoneHandle(phone) {
      this.phone = phone;
    },
    selectCodeHandle: function selectCodeHandle(code, country) {
      this.code = code;
      this.country = country;
    },
    next: function next() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var IPCountryCode, rp;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return util.getCountryCodeByIp(false);
            case 2:
              _context.t0 = _context.sent.toUpperCase();
              if (_context.t0) {
                _context.next = 5;
                break;
              }
              _context.t0 = 'CN';
            case 5:
              IPCountryCode = _context.t0;
              console.log(IPCountryCode, '--IPCountryCode--');
              if (_this.phone && !_this.errorTxt && !_this.cover) {
                _this.cover = true;
                rp = _this.phone.replace(/\b(0{1})/gi, '');
                api.userIsExist("".concat(_this.code).concat(rp)).then(function (data) {
                  // 手机号0开头的去掉0
                  // const rp = this.phone.replace(/\b(0{1})/gi, '');
                  // 12007 12006 12005 账号存在
                  if (data.ret === '12007' || data.ret === '12006' || data.ret === '12005') {
                    _this.$emit('inputPhone', 'login', "".concat(_this.code).concat(rp), _this.code, _this.country);
                  } else if (data.ret === '12000') {
                    // 12000 新用户输入前几位 为0 的手机号 进行了拦截
                    // 提示 手机号不合法
                    _this.errorTxt = _this.$t(_this.$loginLangPrefix('userSign.webLoginPhoneTips12000'));
                    _this.$emit('inputPhone', 'input', "".concat(_this.code).concat(rp), _this.code, _this.country);
                  } else if (_this.code === '86' && (IPCountryCode === 'CN' || !IPCountryCode)) {
                    // 中国区 为注册 用户 不跳转登录
                    _this.errorTxt = _this.$t(_this.$loginLangPrefix('userSign.webLoginPhoneTipsDisableCN'));
                    _this.$emit('inputPhone', 'input', "".concat(_this.code).concat(rp), _this.code, _this.country);
                  } else {
                    _this.$emit('inputPhone', 'reg', "".concat(_this.code).concat(rp), _this.code, _this.country);
                  }
                  _this.cover = false;
                }).catch(function (response) {
                  _this.cover = false;
                  if (response.errorMessageTMXTip) {
                    return;
                  }
                  _this.errorTxt = _this.$t(_this.$loginLangPrefix('userSign.sysError'));
                  // this.$emit('inputPhone', 'login', `${this.code}`, this.code, this.country);
                });
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};